// FIRST import — installs the default-deny fetch guard at module-load time, before
// any leaf module body can call fetch. Do not move below other imports.
import "./shims/fetch-guard";

import "./app.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/router";
import { DemoStateProvider } from "./demo/DemoStateProvider";
import { LiveRoomProvider } from "./demo/live/LiveRoom";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LiveRoomProvider>
      <DemoStateProvider>
        <RouterProvider router={router} />
      </DemoStateProvider>
    </LiveRoomProvider>
  </StrictMode>,
);
